import { observable } from "mobx";


export default class CifStore {

    @observable loadingMoedas;
    @observable moedas;
    @observable valorCIF;
    @observable valorCIFReal
    @observable valorCIFDolar
    @observable valorCIFEuro
    @observable dataRI;
    @observable dataSaidaCarga;
    @observable calcular;

    constructor(service, cifReal=null, cifDolar=null, cifEuro=null) {

        this.loadingMoedas = false
        this.moedas = []
        this.moedaSelecionada = "R"
        this.calcular = false;

        this.dataRI = null;
        this.dataSaidaCarga = null;

        this.valorCIF = cifReal;
        this.valorCIFReal = cifReal;
        this.valorCIFDolar = cifDolar;
        this.valorCIFEuro = cifEuro;

        this.service = service;

        this.ListarMoedas();
    }

    ListarMoedas = () => {
        this.loadingMoedas = true;
        this.service.ListarMoedas().then(response => {
            if(response && response.data) {
                this.moedas = response.data.map(moeda => ({ id: moeda.Descr, value: moeda.Codigo, label: moeda.Descr, checked: moeda.Codigo === this.moedaSelecionada }));
                if(this.moedas.length > 0) this.moedaSelecionada = this.moedas[0].value;
            }
        }).catch(err => console.error(err)
        ).finally(() => {this.loadingMoedas = false});
    }

    setMoeda = (value) => {
        this.moedaSelecionada = value;
        switch(value) {
            case 'R':
                this.valorCIF = this.valorCIFReal;
            break;
            case 'D':
                this.valorCIF = this.valorCIFDolar;
            break;
            case 'E':
                this.valorCIF = this.valorCIFEuro;
            break;
            default:
                this.valorCIF = ""
        }
    }

    setDataRI = (value) => {
        this.dataRI = value;
    }

    setDataSaidaCarga = (value) => {
        this.dataSaidaCarga = value;
    }
    
    setValorCif = (value) => {
        this.valorCIF = value;
    }
}


// WEBPACK FOOTER //
// ./src/modules/faturamento/orcamento/importacao/stores/CifStore.js